import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

/**
 * Thrown when an operation is cancelled via an AbortSignal (timeout or
 * external abort). The `AbortError` name mirrors the platform
 * `DOMException` convention so existing `error.name === 'AbortError'`
 * classification keeps working without depending on DOM types in
 * backend code.
 */
export class AbortError extends EluveError {
  static override readonly errorName = 'AbortError';
  readonly logLevel: LogLevel = 'warn';

  constructor(message = 'Operation aborted', args?: EluveErrorArgs) {
    super(message, args);
  }
}
